import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { VIEW, YES, ACTIVE } from "const"
import { hasProjectAccess } from "client/utils"
import {
    PRM_CC_REQUIREMENT_REVIEW,
    StoreType,
    setCcRequirementBaseReviewRoute,
    moduleIds,
} from "client/store"
import {
    projectsRoute,
    projectBaseRoute,
    projectCcRequirementsReviewRoute,
} from "client/parts/routes"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"
import CcRequirementReviewList from "./list"

const CcRequirementReview = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const dispatch = useDispatch()

    const { ccModuleAccess } = packageSettings
    const moduleAccess = ccModuleAccess === YES && moduleList[moduleIds.cc].status === ACTIVE
    const viewAccess = hasProjectAccess(PRM_CC_REQUIREMENT_REVIEW, VIEW)

    const baseRouteMask = `${projectBaseRoute}${projectCcRequirementsReviewRoute}`
    const baseRoute = `${projectsRoute}/${VIEW}/${project.id}${projectCcRequirementsReviewRoute}`

    useEffect(() => {
        dispatch(setCcRequirementBaseReviewRoute(baseRoute))
    }, [])

    if (!moduleAccess || !viewAccess) return <AccessDenied />
    return (
        <Switch>
            <Route
                path={`${baseRouteMask}/requirement/:requirementId/revision/:revisionId`}
                component={CcRequirementReviewList}
            />
            <Route
                path={baseRouteMask}
                component={CcRequirementReviewList}
            />
        </Switch>
    )
}
export default CcRequirementReview
